<template>
  <div class="section-navs">
    <h2 class="m-title nav-title">
      <slot name="title" />
    </h2>

    <div
      v-if="sportList.length"
      class="nav-wrap"
    >
      <SportsNav
        :sport-id="sportId"
        :sport-list="sportList"
        :track-type="trackType"
        @change="onChangeSport"
      />
    </div>
  </div>
</template>

<script>
import SportsNav from '../components/SportsNav'

export default {
  name: 'SectionNavs',
  components: {
    SportsNav
  },
  props: {
    sportId: {
      type: String,
      default: ''
    },
    sportList: {
      type: Array,
      default: () => []
    },
    // 埋点类型
    trackType: {
      type: String,
      default: ''
    }
  },
  methods: {
    onChangeSport(sportId, sportName) {
      if (sportId === this.sportId) return
      this.$emit('change', sportId, sportName)
    }
  }
}
</script>

<style lang="scss" scoped>
.m-sub-navs {
  min-width: auto;
  padding: 0;
}

.nav-title {
  height: 100%;
  padding: 0 18px 0 20px;
  border-radius: 20px 0 0;
  background-image: linear-gradient(-26deg, #101010 32%, rgba(255,202,39,37%) 100%);
  line-height: 43px;
}

.nav-wrap {
  position: relative;
  overflow: hidden;
  flex: 1;
  padding: 0 0 0 20px;
}

.section-navs {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 44px;
  align-items: center;
  padding: 0 15px 0 0;
  border-radius: 20px 20px 0 0;
  background: #222;

  &::after {
    position: absolute;
    top: 0;
    right: -15px;
    width: 55px;
    height: 44px;
    border-radius: 0 20px 0 0;
    background: linear-gradient(90deg, rgba(41, 41, 41, 0%) 0%, #292929 100%);
    content: "";
  }
}

[data-mode="light"] {
  .section-navs {
    background-image: linear-gradient(180deg, #FFF 0%, #F8F8F8 100%);

    &::after {
      background-image: linear-gradient(90deg, rgba(255,255,255,0%) 27%, #F8F8F8 81%);
    }

    .nav-title {
      background-image: linear-gradient(270deg, #FFF5D5 0%, #FFF 67%);
    }

  }
}
</style>
